<template>
  <result-list />
</template>
<script>
import ResultList from "@/components/ResultList.vue";
import store from "@/store.js";
import { Victim } from "../../models";

export default {
  components: {
    ResultList,
  },
  created() {
    this.fetchData();
  },
  watch: {
    $route: "fetchData",
  },
  methods: {
    fetchData: function () {
      const query = Object.assign({}, this.$route.query);
      this.state.query = query;
      this.state.model = Victim;
      this.state.loading = true;

      const request = this.state.model.fetchMany(query);
      const success = (result) => {
        this.state.instances = result;
        this.state.total = result.total;
        this.state.current = result.current;
        this.state.loading = false;

      };
      const error = (result) => {
        this.state.loading = false;
      }
      request.then(success, error);
    },
  },
  data() {
    return {
      state: store.state,
    };
  },
};
</script>
